export const ACTION_TYPES = {
  LOGOUT: "LOGOUT",
  LOGIN: "LOGIN",
  ADD_TO_CART: "ADD_TO_CART",
  DELETE_FROM_CART: "DELETE_FROM_CART",
  INCREASE_QUANTITY: "INCREASE_QUANTITY",
  DECREASE_QUANTITY: "DECREASE_QUANTITY",
  RERENDER_START: "START_RERENDER",
  RERENDER_STOP: "STOP_RERENDER",
  SORT_POPULARITY: "SORT_POPULARITY",
  SORT_HIGH_TO_LOW: "SORT_HIGH_TO_LOW",
  SORT_LOW_TO_HIGH: "SORT_LOW_TO_HIGH",
};
